import createVueApp from '@phoenix/createVueApp';
import ContactForm from '../components/form/ContactForm.vue';

const app = createVueApp({}, true);
app.component('ContactForm', ContactForm);
app.mount('#phoenix-contact-form');
